import { type HTMLAttributes, useContext } from 'react';
import styled from 'styled-components';
import { ItemContext } from 'modules/react-accordion/components/accordionItem';
import { hasTeaserGuard } from './withTeaser';
import { Spacing16 } from 'autogen/design-tokens/tokens';

const AccordionItemPanelElement = styled.div`
    padding: ${Spacing16};
    overflow: hidden;
`;

export default function AccordionItemPanel(props: HTMLAttributes<HTMLDivElement>): JSX.Element {
    const { isExpanded } = useContext(ItemContext);

    return <AccordionItemPanelElement {...props} hidden={!hasTeaserGuard(props) && !isExpanded} />;
}
